import { render, staticRenderFns } from "./ContactWrapper.vue?vue&type=template&id=298221ca"
import script from "./ContactWrapper.vue?vue&type=script&lang=js"
export * from "./ContactWrapper.vue?vue&type=script&lang=js"
import style0 from "./ContactWrapper.vue?vue&type=style&index=0&id=298221ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports